module.exports = __webpack_public_path__ + "img/product12.c04d56ec.png";